import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LanguageService } from '../language/language.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private http: HttpClient, private languageService: LanguageService) {}

  getMenu(){
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}admin/menus?lang=${lang}`);
  }

  getMenuItem(id: number){
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}admin/menu/item/${id}?lang=${lang}`);
  }

  updateSort(data: any){
    const lang = this.languageService.getLanguage();
    return this.http.post(`${environment.apiUrl}admin/menu/update/sort?lang=${lang}`, data);
  }

 
  getMenuPagesFlat(){
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}admin/menu/pages/flat?lang=${lang}`);
  }

  saveMenu(data: any){
    const lang = this.languageService.getLanguage();
    return this.http.post(`${environment.apiUrl}admin/menu/update-structure?lang=${lang}`, data);
  }

  // updateMenuItem(data: any){
  //   const lang = this.languageService.getLanguage();
  //   return this.http.put(`${environment.apiUrl}admin/menu/update-menu-item?lang=${lang}`, data);
  // }

  updateMenuItem(id: number, formData: FormData) {
    const lang = this.languageService.getLanguage() || 'geo';

    const params = new HttpParams().set('lang', lang);

    // თუ backend-ში update route PUT არის, მაგრამ ჩვენ POST-ით ვაგზავნით:
    if (!formData.has('_method')) {
      formData.append('_method', 'PUT');
    }

    return this.http.post(`${environment.apiUrl}admin/menu/update/${id}`, formData, { params });
  }

  createMenuItem(data: any){
    const lang = this.languageService.getLanguage();
    return this.http.post(`${environment.apiUrl}admin/menu/storage?lang=${lang}`, data);
  }

  deleteMenuItem(id: number){
    const lang = this.languageService.getLanguage() || 'geo';
    const params = new HttpParams().set('lang', lang);
    return this.http.delete(`${environment.apiUrl}admin/menu/destroy/${id}`, { params });
  }

  checkSlug(slug: string) {
    // მაგალითი: GET /api/admin/slug/check?slug=test
    return this.http.get(`${environment.apiUrl}admin/slug/check`, { params: { slug } });
  }

}
